import React, { createContext, useContext, useState } from "react";

const GeneralContextProvider = createContext();

const GeneralContex = ({ children }) => {
  const [loader, setloader] = useState(false);
  const [alert, setAlert] = useState({
    cond: false,
    message: "",
    severity: "",
  });

  const initAlert = (message = "", severity = "success") => {
    setAlert((prev) => ({ ...prev, cond: true, message, severity }));
  };

  const resetAlert = () => setAlert({ cond: false, message: "", severity: "" });
  return (
    <GeneralContextProvider.Provider
      value={{ loader, setloader, alert, setAlert, initAlert, resetAlert }}
    >
      {children}
    </GeneralContextProvider.Provider>
  );
};

export default GeneralContex;

export const GeneralContextFunc = () => useContext(GeneralContextProvider);
